import React, { useEffect, useState } from "react";
import { BsPeople } from "react-icons/bs";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { roles, teamRoles } from "../../../helpers/constantVariables";
import { useStores } from "../../../store";
import Loader from "../loader";
import { useObserver } from "mobx-react";

const Addnumber = ({ buttonName, onClick, edit, data }) => {
  const { RecuiterStore } = useStores();

  const [isEmailSaved, setIsEmailSaved] = useState(false);

  const [selectedValue, setSelectedValue] = useState("");

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    if (edit) {
      document.getElementById("name").value = data?.name ?? "";
      document.getElementById("email").value = data.email ?? "";
      document.getElementById("role").value = data.designation ?? "";
      document.getElementById("access").value = data.roleId ?? "";
      setIsEmailSaved(true);
    }
  }, [edit]);

  return useObserver(() => (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const data1 = {
          name: document.getElementById("name").value,
          email: document.getElementById("email").value,
          designation: document.getElementById("role").value,
          accessType: document.getElementById("access").value,
          roleId:
            document.getElementById("access").value === "viewer"
              ? "6971bb50ce17d9413a277db4"
              : JSON.parse(localStorage.getItem("user"))?.role?._id || "",
          ownerId: JSON.parse(localStorage.getItem("user"))?._id || "",
          employer:
            document.getElementById("access").value === "viewer"
              ? "6971bb50ce17d9413a277db4"
              : JSON.parse(localStorage.getItem("user"))?.role?._id || "",
        };

        if (edit) {
          const { ownerid, ...data2 } = data1;
          console.log(data2, "data2");
          RecuiterStore.updateMember(data2, data._id);
        } else {
          console.log(data1, "data1");
          RecuiterStore.addMember(data1);
        }

        setIsEmailSaved(true);
        onClick();
      }}
      className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40 flex items-center justify-center"
    >
      <Loader loader={RecuiterStore.loader} />
      <div
        onClick={(e) => e.stopPropagation()}
        className=" rounded-2xl w-[75vw] md:w-[35vw] lg:w-[35vw] h-auto max-w-2xl mx-auto p-5 md:p-5 bg-white"
      >
        <div
          onClick={onClick}
          className="text-[#FF6B00] ml-[94%] md:ml-[96%] mr-0 cursor-pointer"
        >
          <IoIosCloseCircleOutline />
        </div>
        <div className="flex flex-col items-center mt-3 md:mt-4 justify-center space-y-2">
          <div className="flex items-center justify-center space-x-3 md:space-x-5 mb-3 md:mb-4">
            <div className="border-2 mb-4 rounded-full p-1.5 md:p-2 bg-gray-200">
              <BsPeople className="text-gray-600 border-2 text-sm md:text-lg" />
            </div>
            <h1 className="text-lg md:text-xl font-bold mb-4">
              Add New Member
            </h1>
          </div>
          <div className="mb-3 md:mb-5 w-full md:w-[80%]">
            <label
              htmlFor="name"
              className="text-gray-700 font-medium block mb-1 "
            >
              Name of the team member
            </label>
            <input
              id="name"
              type="text"
              required
              placeholder="Balaji Sundarapu"
              className="w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00] text-sm"
              onBlur={(e) => {
                if (e.target.value.trim() === "") {
                  e.target.value = "";
                }
              }}
            />
          </div>
          <div className="mb-3 md:mb-5 w-full md:w-[80%]">
            <label
              htmlFor="email"
              className="text-gray-700 font-medium block mb-1"
            >
              E-mail
            </label>
            <input
              id="email"
              type="email"
              required
              placeholder="Balajisundarapu15@gmail.com"
              readOnly={isEmailSaved}
              className="w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00] text-sm"
            />
          </div>
          <div className="mb-3 md:mb-5 w-full md:w-[80%]">
            <label
              htmlFor="role"
              className="text-gray-700 font-medium block mb-1"
            >
              Role
            </label>
            <input
              required
              id="role"
              type="text"
              placeholder="Project lead"
              className="w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00] text-sm"
            />
          </div>
          <div className="mb-3 md:mb-5 w-full md:w-[80%]">
            <label
              htmlFor="access"
              className="text-gray-700 font-medium block mb-1"
            >
              Access
            </label>
            <select
              id="access"
              required
              className={`w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF6B00] text-sm ${
                selectedValue === "" ? "text-gray-300" : "text-black"
              }`}
              onChange={handleSelectChange}
            >
              <option value="" className="text-gray-300">
                Select Access
              </option>
              {teamRoles.map((role) => (
                <option key={role.id} value={role.id} className="text-black">
                  {role.role}
                </option>
              ))}
            </select>
          </div>
          <div className="ml-auto mr-0 md:mr-16">
            <button
              className="bg-[#FF6B00] hover:bg-orange-200 mb-2 md:-mr-2 text-white font-bold py-1.5 px-4 md:px-8  mt-4 rounded text-xs md:text-sm"
              type="submit"
            >
              {buttonName}
            </button>
          </div>
        </div>
      </div>
    </form>
  ));
};

export default Addnumber;
